module.exports = __webpack_public_path__ + "img/whatsapp-icon.8b357b47.png";